import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import usePages from "../../../Hooks/Display/usePages";
import { useEffect, useState } from "react";
import { TOGGLE_EDIT_PAGE_DIALOG, UPDATE_PAGE } from "../../../Context/Display/Pages/PagesContextEvents";
import { updatePage } from "../../../API/Display/Display";
import { getPageByProperty } from "../utils";

function EditPageDialog() {

    const [{ pages, editPageIndex }, dispatchPageEvent] = usePages();

    const index = editPageIndex.split("_").map(i => parseInt(i));
    const page = pages[index[0]].items[index[1]];

    const [pageName, setPageName] = useState(page.pageName);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (isPageNameUsed()) {
            setError("Page name is already used.");
        } else {
            setError(null);
        }
    }, [pageName])

    function handlePageNameChange(event) {
        setPageName(event.target.value);
    }

    function isPageNameUsed() {
        const pageWithSameName = getPageByProperty(pages, "pageName", pageName);
        debugger
        return pageWithSameName !== null && pageWithSameName._id !== page._id;
    }

    function handleCancel() {
        dispatchPageEvent({
            type: TOGGLE_EDIT_PAGE_DIALOG,
            payload: null
        })
    }

    async function handleUpdatePage() {
        await updatePage(page._id, { pageName });
        dispatchPageEvent({
            type: UPDATE_PAGE,
            payload: {
                parentId: page.parentId,
                pageId: page._id,
                pageName
            }
        })
        toggleEditDialog();
    }

    function toggleEditDialog() {
        dispatchPageEvent({
            type: TOGGLE_EDIT_PAGE_DIALOG,
            payload: null
        })
    }

    return (
        <Dialog
            title={"Update Page"}
        >
            <form className="container-fluid">
                <div className="row form-group">
                    <label className="form-label">
                        Page Name
                        {
                            error &&
                            <span className="text-danger">
                                &nbsp;&nbsp;{error}
                            </span>
                        }
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        value={pageName}
                        onChange={handlePageNameChange}
                    />
                </div>
            </form>
            <DialogActionsBar layout="end">
                <button
                    className="btn btn-secondary"
                    onClick={handleCancel}
                >
                    Cancel
                </button>
                <button
                    className="btn btn-primary"
                    onClick={handleUpdatePage}
                    disabled={pageName.trim() === page.pageName.trim() || error}
                >
                    Update
                </button>
            </DialogActionsBar>
        </Dialog>
    )
}

export default EditPageDialog;